import {
  DEFAULT_LOCALE,
  getLocaleFromPathname,
  localizePath,
} from "./localeRouting";

const PURCHASE_SUCCESS_TOKEN_KEY = "lukkey_purchase_success_token";

export function getActiveLocaleFromPath(pathname = "/") {
  return getLocaleFromPathname(pathname) || DEFAULT_LOCALE;
}

export function getPurchaseSuccessPath(pathname = "/") {
  const locale = getActiveLocaleFromPath(pathname);
  return localizePath("/purchase/success", locale);
}

export function createPurchaseSuccessToken() {
  const seed = `${Date.now()}-${Math.random()}-${Math.random()}`;
  return seed.replace(/\./g, "");
}

export function rememberPurchaseSuccessToken(token) {
  if (typeof window === "undefined" || !token) return;
  window.sessionStorage.setItem(PURCHASE_SUCCESS_TOKEN_KEY, token);
}

export function readPurchaseSuccessToken() {
  if (typeof window === "undefined") return "";
  return window.sessionStorage.getItem(PURCHASE_SUCCESS_TOKEN_KEY) || "";
}

export function clearPurchaseSuccessToken() {
  if (typeof window === "undefined") return;
  window.sessionStorage.removeItem(PURCHASE_SUCCESS_TOKEN_KEY);
}

export function getPurchaseSuccessUrl(pathname = "/") {
  const token = createPurchaseSuccessToken();
  rememberPurchaseSuccessToken(token);

  if (typeof window === "undefined") {
    const fallbackUrl = new URL("https://lukkey.local");
    fallbackUrl.pathname = getPurchaseSuccessPath(pathname);
    fallbackUrl.searchParams.set("purchaseToken", token);
    return fallbackUrl.pathname + fallbackUrl.search;
  }

  const url = new URL(getPurchaseSuccessPath(pathname), window.location.origin);
  url.searchParams.set("purchaseToken", token);
  return url.toString();
}

export function appendCheckoutReturnParams(urlLike, pathname = "/") {
  const url = new URL(String(urlLike));
  const successUrl = getPurchaseSuccessUrl(pathname);

  url.searchParams.set("return_to", successUrl);
  url.searchParams.set("checkout[attributes][success_url]", successUrl);

  return url;
}
